module.exports = __webpack_public_path__ + "static/img/ruzhu_center_bg_url.418aaa68.png";